import {
  FAQ_LOADING,
  FAQ_SUCCESS,
  FAQ_FAILED
} from '../actions/faqActions'
const FAQ = (state = {
  isLoading: false,
  error: null,
  faqs: {} }, action) => {
  switch (action.type) {
    case FAQ_LOADING:
      return Object.assign({}, state, {
        isLoading: true,
        faqs: null,
        error: null
      })
    case FAQ_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        faqs: action.response,
        error: null
      })
    case FAQ_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        faqs: null,
        error: action.error
      })
    default:
      return state
  }
}
export default FAQ



// WEBPACK FOOTER //
// ./src/redux/reducers/faqReducer.js